module.exports = __webpack_public_path__ + "img/mail.03e96f16.svg";